import { PagedGridFacade } from '../../services';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit
} from '@angular/core';
import { Observable } from 'rxjs';
import { PageInfo } from '../../models';

@Component({
  selector: 'app-grid-pagination-buttons',
  templateUrl: './grid-pagination-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridPaginationButtonsComponent implements OnInit {
  private readonly pagedGridFacade = inject(PagedGridFacade);

  @Input({ required: true })
  gridInstanceId: string;

  pageInfo$: Observable<PageInfo>;

  ngOnInit(): void {
    this.pageInfo$ = this.pagedGridFacade.getPageData(this.gridInstanceId);
  }

  selectPage(pageIndex: number): void {
    this.pagedGridFacade.selectPage(this.gridInstanceId, pageIndex);
  }
}
